module.exports = __webpack_public_path__ + "static/elkabetz-hex-light-ae6f81b8cf89ef9ada9b1d3a4f72058b.png";